"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const getComponentDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || "Component";
exports.getComponentDisplayName = getComponentDisplayName;
//# sourceMappingURL=getComponentDisplayName.cjs.map
